/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import * as _ from 'lodash';
import { uniqueId } from 'lodash';
import moment from 'moment';
import validator from 'validator';
import ReactResizeDetector from 'react-resize-detector';
import { removeTimeZoneFromDate } from 'utils/dateUtil';

import injectReducer from 'utils/injectReducer';
import { makeSelectClaimTypeList } from 'containers/FastCover/StepWhatHappened/selectors';
import { makeSelectStepOverseasMedical, makeSelectStepOverseasMedicalErrors } from './selectors';
import { makeSelectStepCancellationAdditional } from '../StepCancellationAdditional/selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import P from '../../../components/P';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetAccidentalDeath,
  resetContactEmergencyAssistance,
  resetFormData,
  resetLossOfIncome,
  resetOverseasEmergencyMedicalOrDentalExpenses,
} from './actions';
import ControlContainer from '../components/ControlContainer';
import DatePicker from '../components/DatePicker/index';
import TimePickerInput from '../../../components/TimePickerInput';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { MedicalExpenses } from './components/MedicalExpenses';
import { required } from '../../../utils/validation/validator';
import { saveFormData, emailMeDocument } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import StepOverseasMedicalShared from './components/StepOverseasMedicalShared';
import { stepOverseasMedicalExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { makeSelectMedicalCertificateFormLink, makeSelectMedicalAuthorityFormLink } from '../../App/selectors';

export class StepOverseasMedical extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentDidMount() {
    const claimTypesList = !!this.props.claimTypes && (typeof this.props.claimTypes.toJS === 'function') ? this.props.claimTypes.toJS() : this.props.claimTypes;
    const hasClaimTypesLoaded = claimTypesList.length > 1;
    if (!hasClaimTypesLoaded) {
      return;
    }
    this.props.onFormDataChange('form.areYouClaimingForEmergencyMedicalAndHospitalExpenses', !!stepOverseasMedicalExpenseLookup.areYouClaimingForEmergencyMedicalAndHospitalExpenses.claimCode ? 'true' : 'false');
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(7);
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  onMedicalExpansesChange = (data) => {
    this.props.onFormDataChange('form.medicalExpenses', fromJS(data));
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  onInputComponentChange = (propertyName) => (event) => {
    if (event.target.checked) {
      const selectedValue = this.getBenefitOption();

      this.props.adjust();

      if (!!selectedValue && selectedValue.key !== propertyName) {
        this.props.onFormDataChange(`form.${selectedValue.key}`, 'false');
      }
    }
    this.onChange(`${propertyName}`)(event);
    // this.props.makeDirty(5);
  };

  getValidationErrors() {
    const {
      medicalExpenses,
    } = this.props.form;
    const errors = [];
    if (this.validateTableField(medicalExpenses)) {
      errors.push({
        field: 'medicalExpenses',
        message: 'Medical Expenses table fields are required fields.',
      });
    }

    return errors;
  }

  getBenefitOption = () => {
    const {
      areYouClaimingForOverseas247,
      areYouClaimingForEmergencyMedicalAndHospitalExpenses,
      areYouClaimingForEmergencyDental,
      areYouClaimingForEmergencyEvacuation,
      areYouClaimingForHospitalCashPayment,
      areYouClaimingForPermanentDisability,
      areYouClaimingForLossOfIncome,
    } = this.props.form;

    const benefitOptions = [
      {
        key: 'areYouClaimingForOverseas247',
        value: areYouClaimingForOverseas247,
      },
      {
        key: 'areYouClaimingForEmergencyMedicalAndHospitalExpenses',
        value: areYouClaimingForEmergencyMedicalAndHospitalExpenses,
      },
      {
        key: 'areYouClaimingForEmergencyDental',
        value: areYouClaimingForEmergencyDental,
      },
      {
        key: 'areYouClaimingForEmergencyEvacuation',
        value: areYouClaimingForEmergencyEvacuation,
      },
      {
        key: 'areYouClaimingForHospitalCashPayment',
        value: areYouClaimingForHospitalCashPayment,
      },
      {
        key: 'areYouClaimingForPermanentDisability',
        value: areYouClaimingForPermanentDisability,
      },
      {
        key: 'areYouClaimingForLossOfIncome',
        value: areYouClaimingForLossOfIncome,
      },
    ];

    const result = benefitOptions.find(
      (benefitOption) => benefitOption.value === 'true'
    );

    return result;
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);

    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
    // this.props.makeDirty(7);
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.emailMeDocument();
  };

  checkRender() {
    const {
      areYouClaimingForOverseas247,
      areYouClaimingForEmergencyMedicalAndHospitalExpenses,
      areYouClaimingForEmergencyDental,
      areYouClaimingForEmergencyEvacuation,
      areYouClaimingForHospitalCashPayment,
      areYouClaimingForPermanentDisability,
      areYouClaimingForLossOfIncome,
    } = this.props.form;

    return ![
      areYouClaimingForOverseas247,
      areYouClaimingForEmergencyMedicalAndHospitalExpenses,
      areYouClaimingForEmergencyDental,
      areYouClaimingForEmergencyEvacuation,
      areYouClaimingForHospitalCashPayment,
      areYouClaimingForPermanentDisability,
      areYouClaimingForLossOfIncome,
    ].find((o) => o !== 'false');
  }

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  renderClaimNote() {
    return (
      <div className="row">
        <div className="form-group col-12">
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.toAssistYourClaim} />
          </P>
          <ul style={{ paddingLeft: 20 }}>
            <li>
              <FormattedMessage {...messages.toAssistYourClaimDetail1} />
            </li>
            <li>
              <FormattedMessage {...messages.toAssistYourClaimDetail2} />
            </li>
          </ul>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.document} />
          </P>
          <StepOverseasMedicalShared />
        </div>
        <div className="form-group col-12">
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.provideExplanation} />
          </P>
        </div>
      </div>
    );
  }

  renderClaimNoteLossOfIncome() {
    return (
      <div className="row">
        <div className="form-group col-12">
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.toAssistYourClaim} />
          </P>
          <ul style={{ paddingLeft: 20 }}>
            <li>
              <FormattedMessage {...messages.toAssistYourClaimDetail1} />
            </li>
            <li>
              <FormattedMessage {...messages.toAssistYourClaimDetail2} />
            </li>
          </ul>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.document} />
          </P>
          <ol>
            <li>
              <FormattedMessage {...messages.document9} />
            </li>
            <li>
              <FormattedMessage {...messages.document10} />
            </li>
            <li>
              <FormattedMessage {...messages.document11} />
            </li>
            <li>
              <FormattedMessage {...messages.document12} />
            </li>
          </ol>
        </div>
        <div className="form-group col-12">
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.provideExplanation} />
          </P>
        </div>
      </div>
    );
  }

  renderClaimNoteAccidentalDeath() {
    return (
      <div className="row">
        <div className="form-group col-12">
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.toAssistYourClaim} />
          </P>
          <ul style={{ paddingLeft: 20 }}>
            <li>
              <FormattedMessage {...messages.toAssistYourClaimDetail1} />
            </li>
            <li>
              <FormattedMessage {...messages.toAssistYourClaimDetail2} />
            </li>
          </ul>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.document} />
          </P>
          <ol>
            <li>
              <FormattedMessage {...messages.document13} />
            </li>
            <li>
              <FormattedMessage {...messages.document14} />
            </li>
            <li>
              <FormattedMessage {...messages.document15} />
            </li>
            <li>
              <FormattedMessage {...messages.document16} />
            </li>
            <li>
              <FormattedMessage {...messages.document17} />
            </li>
          </ol>
        </div>
        <div className="form-group col-12">
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.provideExplanation} />
          </P>
        </div>
      </div>
    );
  }

  renderMedicalExpenses() {
    const { medicalExpenses } = this.props.form;
    const newMedicalExpenses = this.appendIds(medicalExpenses);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <PageSectionHeader>
          <FormattedMessage {...messages.medicalExpenses} />
        </PageSectionHeader>
        <MedicalExpenses
          data={newMedicalExpenses}
          onChange={this.onMedicalExpansesChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderClaimingOptions() {
    const {
      areYouClaimingForEmergencyMedicalAndHospitalExpenses,
      areYouClaimingForLossOfIncome,
    } = this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    const isRenderAreYouClaimingForEmergencyMedicalAndHospitalExpenses = !!stepOverseasMedicalExpenseLookup.areYouClaimingForEmergencyMedicalAndHospitalExpenses.claimCode;
    const isRenderareYouClaimingForLossOfIncome = !!stepOverseasMedicalExpenseLookup.areYouClaimingForLossOfIncome.claimCode;

    return (
      <div>
        <div>
          {isRenderAreYouClaimingForEmergencyMedicalAndHospitalExpenses && this.renderExplainForm()}
        </div>

        {isRenderareYouClaimingForLossOfIncome && <div className="row">
          <div className="form-group col">
            <PageSectionHeader>
              <FormattedMessage {...messages.areYouClaimingForLossOfIncome} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForLossOfIncome === 'true'}
                  onChange={this.onChange('form.areYouClaimingForLossOfIncome')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForLossOfIncome === 'false'}
                  onChange={this.onChange('form.areYouClaimingForLossOfIncome')}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>}
        { isRenderareYouClaimingForLossOfIncome && <div className="ml-3">
          {areYouClaimingForLossOfIncome === 'true' &&
            this.renderForLossOfIncome()}
        </div>}
      </div>
    );
  }

  renderInfo() {
    const {
      patientName,
      relationshipToYou,
      patientDateOfBirth,
      medicareNumber,
      whatIsYourInjuryOrIllness,
      didThisOccurWhilstEngagingInSnowSportActivity,
      wasTheInufredIllTravallerAnInpatient,
      dateOfAdmission,
      timeOfAdmission,
      dateOfDischarge,
      timeOfDischarge,
      contactEmergencyAssistance,
      assistanceCaseReferenceNumber,
      dateOfFirstMedicalConsultation,
    } = this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    const newTimeOfAdmission = timeOfAdmission ? moment(timeOfAdmission) : null;
    const newTimeOfDischarge = timeOfDischarge ? moment(timeOfDischarge) : null;
    return (
      <div>
        <div className="row">
          <div className="form-group col-sm-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="patientName"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={patientName}
              fieldName={messages.patientName}
            >
              <Textbox
                disabled={isReadOnly}
                name="patientName"
                type="text"
                onChange={this.handleChange('form.patientName')}
                value={patientName}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.patientName}
                />
              </ErrorMessage>
            </Validate>
          </div>

          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.relationshipToYou} />
            </PageSectionHeader>
            <Textbox
              disabled={isReadOnly}
              name="relationshipToYou"
              type="text"
              onChange={this.handleChange('form.relationshipToYou')}
              value={relationshipToYou}
            />
          </div>
        </div>

        <div className="row">
          <div className="form-group col">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="whatIsYourInjuryOrIllness"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={whatIsYourInjuryOrIllness}
              fieldName={messages.whatIsYourInjuryOrIllness}
            >
              <TextArea
                disabled={isReadOnly}
                name="whatIsYourInjuryOrIllness"
                type="text"
                onChange={this.handleChange('form.whatIsYourInjuryOrIllness')}
                value={whatIsYourInjuryOrIllness}
                isSummary={isSummary}

              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.whatIsYourInjuryOrIllness}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.didThisOccurWhilstEngagingInSnowSportActivity}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={
                    didThisOccurWhilstEngagingInSnowSportActivity === 'true'
                  }
                  onChange={this.onChange(
                    'form.didThisOccurWhilstEngagingInSnowSportActivity'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={
                    didThisOccurWhilstEngagingInSnowSportActivity === 'false'
                  }
                  onChange={this.onChange(
                    'form.didThisOccurWhilstEngagingInSnowSportActivity'
                  )}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>


        </div>
        <div className={'row'}>
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.wasTheInufredIllTravallerAnInpatient}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={wasTheInufredIllTravallerAnInpatient === 'true'}
                  onChange={this.onChange(
                'form.wasTheInufredIllTravallerAnInpatient'
              )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={wasTheInufredIllTravallerAnInpatient === 'false'}
                  onChange={this.onChange(
                'form.wasTheInufredIllTravallerAnInpatient'
              )}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {wasTheInufredIllTravallerAnInpatient === 'true' && <div className="row">
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.dateOfAdmission} />
            </PageSectionHeader>
            <DatePicker
              disabled={isReadOnly}
              name="dateOfAdmission"
              type="text"
              onDayChange={this.handleDayChange('form.dateOfAdmission')}
              value={dateOfAdmission}
              placeholder=""
            />
          </div>
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.timeOfAdmission} />
            </PageSectionHeader>
            <TimePickerInput
              allowEmpty
              showSecond={false}
              onChange={this.onChange('form.timeOfAdmission')}
              value={newTimeOfAdmission}
              disabled={isReadOnly}
            />
          </div>
        </div>}

        {wasTheInufredIllTravallerAnInpatient === 'true' && <div className="row">
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.dateOfDischarge} />
            </PageSectionHeader>
            <DatePicker
              disabled={isReadOnly}
              name="dateOfDischarge"
              type="text"
              onDayChange={this.handleDayChange('form.dateOfDischarge')}
              value={dateOfDischarge}
              placeholder=""
            />
          </div>
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.timeOfDischarge} />
            </PageSectionHeader>
            <TimePickerInput
              allowEmpty
              showSecond={false}
              onChange={this.onChange('form.timeOfDischarge')}
              value={newTimeOfDischarge}
              disabled={isReadOnly}
            />
          </div>
        </div>}


        <div className="row">
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.contactEmergencyAssistance} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={contactEmergencyAssistance === 'true'}
                  onChange={this.onChange('form.contactEmergencyAssistance')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={contactEmergencyAssistance === 'false'}
                  onChange={this.onChange('form.contactEmergencyAssistance')}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          {this.props.form.contactEmergencyAssistance === 'true' && (
            <div className="form-group col-sm-6">
              <PageSectionHeader>
                <FormattedMessage {...messages.assistanceCaseReferenceNumber} />
              </PageSectionHeader>
              <Textbox
                disabled={isReadOnly}
                name="assistanceCaseReferenceNumber"
                type="text"
                onChange={this.handleChange(
                    'form.assistanceCaseReferenceNumber'
                  )}
                value={assistanceCaseReferenceNumber}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  renderExplainForm() {
    const {
      hasInjuredOrIllTravellerPreviously,
    } = this.props.form;
    const { isSummary, submitted, medicalAuthorityFormLink, medicalCertificateFormLink } = this.props;
    const isReadOnly = submitted || isSummary;
    const { enableTime } = this.props.stepCancellationAdditionalData;
    const buttonEmailMeDisable = !!enableTime && new Date().getTime() < enableTime;
    return (
      <div>
        {this.renderInfo()}

        <div className="row">
          <div className="form-group col-12">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.hasInjuredOrIllTravellerPreviously}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={hasInjuredOrIllTravellerPreviously === 'true'}
                  onChange={this.onChange(
                    'form.hasInjuredOrIllTravellerPreviously'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={hasInjuredOrIllTravellerPreviously === 'false'}
                  onChange={this.onChange(
                    'form.hasInjuredOrIllTravellerPreviously'
                  )}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        <div className={'row'}>
          <div className="form-group col-sm-8">
            {hasInjuredOrIllTravellerPreviously === 'false' && <ControlContainer>
              <P style={{ fontWeight: 'bold' }}>
                We may need the injured/ill person to complete <a href={medicalAuthorityFormLink} target="_blank">our Medical Authority Form </a> and their usual GP/Specialist to complete <a target="_blank" href={medicalCertificateFormLink}>our Medical Certificate Form </a>
              </P>
            </ControlContainer>}

            {hasInjuredOrIllTravellerPreviously === 'true' && <ControlContainer>
              <P style={{ fontWeight: 'bold' }}>
                We will need the injured/ill person to complete <a href={medicalAuthorityFormLink} target="_blank">our Medical Authority Form </a> and their usual GP/Specialist to complete <a target="_blank" href={medicalCertificateFormLink}>our Medical Certificate Form </a>
              </P>
            </ControlContainer>}
          </div>
          <div className="form-group col-sm-4">
            <AsyncButton
              id={this.emailMeDocumentButton}
              className="btn-noOutline"
              disabled={buttonEmailMeDisable || isReadOnly}
              loading={this.props.loading}
              spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
              onClick={this.handleEmailMeButtonClick}
            >
              Email me these forms
            </AsyncButton>
          </div>
        </div>
        {/* render medical expenses */}
        {this.renderMedicalExpenses()}

      </div>
    );
  }

  renderClaimingForm() {
    return <div>{this.renderClaimingOptions()}</div>;
  }

  renderForLossOfIncome() {
    const {
      plannedReturnToWorkDate,
      incomeLost,
      actualReturnToWorkDate,
    } = this.props.form;
    const {
      patientDateOfBirthLI,
      medicareNumberLI,
      whatIsYourInjuryOrIllnessLI,
      didThisOccurWhilstEngagingInSnowSportActivityLI,
      wasTheInufredIllTravallerAnInpatientLI,
      dateOfAdmissionLI,
      timeOfAdmissionLI,
      dateOfDischargeLI,
      timeOfDischargeLI,
      nameOfPractitionerDentistHospitalLI,
      contactEmergencyAssistanceLI,
      assistanceCaseReferenceNumberLI,
      dateOfFirstMedicalConsultationLI,
    } = this.props.form;
    const newTimeOfAdmission = timeOfAdmissionLI
      ? moment(timeOfAdmissionLI)
      : null;
    const newTimeOfDischarge = timeOfDischargeLI
      ? moment(timeOfDischargeLI)
      : null;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <div className="row">
          <div className="form-group col-md-4 col-sm-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="plannedReturnToWorkDate"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={plannedReturnToWorkDate}
              fieldName={messages.plannedReturnToWorkDate}
            >
              <DatePicker
                position={'top-start'}
                disabled={isReadOnly}
                name="plannedReturnToWorkDate"
                type="text"
                onDayChange={this.handleDayChange(
                  'form.plannedReturnToWorkDate'
                )}
                value={plannedReturnToWorkDate}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.plannedReturnToWorkDate}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-4 col-sm-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="actualReturnToWorkDate"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={actualReturnToWorkDate}
              fieldName={messages.actualReturnToWorkDate}
            >
              <DatePicker
                position={'top-start'}
                disabled={isReadOnly}
                name="actualReturnToWorkDate"
                type="text"
                onDayChange={this.handleDayChange(
                  'form.actualReturnToWorkDate'
                )}
                value={actualReturnToWorkDate}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.actualReturnToWorkDate}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-4 col-sm-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="incomeLost"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={incomeLost}
              fieldName={messages.incomeLost}
            >
              <Textbox
                disabled={isReadOnly}
                name="incomeLost"
                type="number"
                onChange={this.handleChange('form.incomeLost')}
                value={incomeLost}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.incomeLost}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        {/* {this.renderInfo()} */}
      </div>
    );
  }


  render() {
    const { isSummary, submitted, loading } = this.props;

    return (
      <div className="app-content">

        {this.renderClaimingForm()}

        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepOverseasMedical.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.number,
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  emailMeDocument: PropTypes.func,
  stepCancellationAdditionalData: PropTypes.any,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  medicalAuthorityFormLink: PropTypes.any,
  medicalCertificateFormLink: PropTypes.any,
  claimTypes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepOverseasMedical(),
  errors: makeSelectStepOverseasMedicalErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  stepCancellationAdditionalData: makeSelectStepCancellationAdditional(),
  medicalAuthorityFormLink: makeSelectMedicalAuthorityFormLink(),
  medicalCertificateFormLink: makeSelectMedicalCertificateFormLink(),
  claimTypes: makeSelectClaimTypeList(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onReset: () => dispatch(resetFormData()),
  resetOverseasEmergencyMedicalOrDentalExpenses: () =>
    dispatch(resetOverseasEmergencyMedicalOrDentalExpenses()),
  resetAccidentalDeath: () => dispatch(resetAccidentalDeath()),
  resetContactEmergencyAssistance: () =>
    dispatch(resetContactEmergencyAssistance()),
  resetLossOfIncome: () => dispatch(resetLossOfIncome()),
  emailMeDocument: () => dispatch(emailMeDocument()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepOverseasMedical', reducer });

export default compose(
  withReducer,
  withConnect
)(StepOverseasMedical);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOverseasMedical/index.js